import React from "react";
import "./CompanyAndSharesResult.css";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles/Slide5Part1Styles";
import ResultsNavigationBar from "../components/ResultsNavigationBar";
import { explanation } from "../constants/LeaverExplanation";

export function Slide5Part1({
  goodLeaverEventsResult,
  earlyLeaverEventsResult,
  badLeaverEventsResult,
}: {
  goodLeaverEventsResult: {
    tags: string[];
    extra: string;
  };
  earlyLeaverEventsResult: {
    tags: string[];
    extra: string;
  };
  badLeaverEventsResult: {
    tags: string[];
    extra: string;
  };
}) {
  const titles = [
    "Good Leaver Events",
    "Early Leaver Events",
    "Bad Leaver Events",
  ];
  if (
    !goodLeaverEventsResult ||
    !earlyLeaverEventsResult ||
    !badLeaverEventsResult
  ) {
    return <Text>Not all information is filled in for this section</Text>;
  }

  const leaverEvents = [
    goodLeaverEventsResult.tags,
    earlyLeaverEventsResult.tags,
    badLeaverEventsResult.tags,
  ];

  return (
    <View style={styles.backgroundBlue}>
      <ResultsNavigationBar selectIdx={3} />
      <View style={styles.eventsContainer}>
        {titles.map((item, index) => {
          const currentLeaverEvents = leaverEvents[index];
          return (
            <View style={styles.eventsBox} key={index}>
              <View style={styles.titleBox}>
                <Text style={styles.textTitle}>{item}</Text>
              </View>
              <View style={styles.textBox}>
                {currentLeaverEvents
                  ? currentLeaverEvents.map((event, eventIndex) => {
                      if (event !== "Other") {
                        return (
                          <Text style={styles.text} key={eventIndex}>
                            - {explanation[event]}
                          </Text>
                        );
                      }
                    })
                  : null}
              </View>
            </View>
          );
        })}
      </View>
      ;
    </View>
  );
}
